import { Balance, BalanceError } from '../../../../../redux/context/reports/types'
import { INFOBOX_IDS, SPARKLINE_PREFIX } from './infoboxConstants'

export interface InfoboxDisplayData {
  currentValue: number | undefined
  comparisonValue: number | undefined
  growthPercent: number | undefined
  diffAbsolute: number | undefined
  sparklineData: number[]
  combo:
    | {
        currentValue: number | undefined
        comparisonValue: number | undefined
        growthPercent: number | undefined
        diffAbsolute: number | undefined
      }
    | undefined
  errors: BalanceError[]
}

export function mapBalancesToInfobox(balances: Balance[] | undefined): InfoboxDisplayData {
  const bal = (id: string) => balances?.find(b => b.groupId === id)?.value

  const sparklineData =
    balances
      ?.filter(b => typeof b.groupId === 'string' && (b.groupId as string).startsWith(SPARKLINE_PREFIX))
      .sort((a, b) => {
        const idxA = parseInt((a.groupId as string).split('-').pop()!, 10)
        const idxB = parseInt((b.groupId as string).split('-').pop()!, 10)
        return idxA - idxB
      })
      .map(b => b.value ?? 0) ?? []

  const hasCombo = bal(INFOBOX_IDS.comboActual) !== undefined
  const combo = hasCombo
    ? {
        currentValue: bal(INFOBOX_IDS.comboActual),
        comparisonValue: bal(INFOBOX_IDS.comboComparison),
        growthPercent: bal(INFOBOX_IDS.comboGrowth),
        diffAbsolute: bal(INFOBOX_IDS.comboDiff)
      }
    : undefined

  const errors = balances?.flatMap(b => b.errors ?? []).filter((e, i, arr) => arr.indexOf(e) === i) ?? []

  return {
    currentValue: bal(INFOBOX_IDS.actual),
    comparisonValue: bal(INFOBOX_IDS.comparison),
    growthPercent: bal(INFOBOX_IDS.growth),
    diffAbsolute: bal(INFOBOX_IDS.diff),
    sparklineData,
    combo,
    errors
  }
}
